<div class="topline">
  <h2>Campaigns</h2>
  <button mat-raised-button color="primary" (click)="addCampaign()">Add Campaign</button>
</div>

<div class="filters">
  <mat-form-field appearance="outline" class="search">
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="searchValue" (ngModelChange)="queueFilter($event)">
  </mat-form-field>
</div>

<div class="scroll-container" (scroll)="onScroll($event)">
  <table mat-table [dataSource]="items" class="table">
    <ng-container matColumnDef="campaignName">
      <th mat-header-cell *matHeaderCellDef>Campaign Name</th>
      <td mat-cell *matCellDef="let campaign">
        <span class="campaign-name-cell">
          <span>{{campaign.campaignName}}</span>
          @if (campaignAppliesToAllBrands(campaign)) {
            <mat-icon
              class="all-brands-warning"
              [matTooltip]="allBrandsCampaignTooltip"
              aria-label="Campaign applies to all brands"
            >warning</mat-icon>
          }
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="brand">
      <th mat-header-cell *matHeaderCellDef>Brand</th>
      <td mat-cell *matCellDef="let campaign">{{getBrandName(campaign)}}</td>
    </ng-container>

    <ng-container matColumnDef="startAt">
      <th mat-header-cell *matHeaderCellDef>Start</th>
      <td mat-cell *matCellDef="let campaign">{{campaign.startAt | date:'MM/dd/yyyy'}}</td>
    </ng-container>

    <ng-container matColumnDef="endAt">
      <th mat-header-cell *matHeaderCellDef>End</th>
      <td mat-cell *matCellDef="let campaign" [style.color]="moment(campaign.endAt) < moment() ? 'red' : 'inherit'">
        {{campaign.endAt | date:'MM/dd/yyyy'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="startingBalance">
      <th mat-header-cell *matHeaderCellDef>Starting Balance</th>
      <td mat-cell *matCellDef="let campaign">{{campaign.startingBalance | currency}}</td>
    </ng-container>

    <ng-container matColumnDef="currentBalance">
      <th mat-header-cell *matHeaderCellDef>Current Balance</th>
      <td mat-cell *matCellDef="let campaign">{{campaign.currentBalance | currency}}</td>
    </ng-container>

    <ng-container matColumnDef="lowBalance">
      <th mat-header-cell *matHeaderCellDef>Low Balance</th>
      <td mat-cell *matCellDef="let campaign">{{campaign.lowBalance | currency}}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let campaign">
        <button
          mat-icon-button
          class="snowman-menu-trigger"
          [matMenuTriggerFor]="campaignActionsMenu"
          [matMenuTriggerData]="{ campaign: campaign }"
          (click)="$event.stopPropagation()"
          aria-label="Campaign actions"
          >
          <mat-icon>more_vert</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="editCampaign(row)"></tr>
  </table>

  @if (loading) {
    <div class="loading">Loading...</div>
  }
  @if (!loading && items.length === 0) {
    <div class="empty">There are no snacks/rewards to show.</div>
  }
</div>

<mat-menu #campaignActionsMenu="matMenu">
  <ng-template matMenuContent let-campaign="campaign">
    <button mat-menu-item (click)="$event.stopPropagation(); editCampaign(campaign)">Edit campaign</button>
    <button mat-menu-item (click)="deleteCampaign($event, campaign)">Delete campaign</button>
  </ng-template>
</mat-menu>
